module.exports = __webpack_public_path__ + "static/img/n1_132.f2c4eea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/page/img/n1_132.jpg
// module id = Kf+w
// module chunks = 2